import { SystemTypeEnum } from '../../model/SystemTypeEnum';
import { SystemTypeActions, SystemTypeActionTypes } from './SystemTypeActions';


export interface SystemTypeState {
  type: SystemTypeEnum;
}

export const initialState: SystemTypeState = {
  type: null
};

export function systemTypeReducer(state: SystemTypeState = initialState, action: SystemTypeActions): SystemTypeState {
  switch (action.type) {
    case SystemTypeActionTypes.InitSystemType: {
      return {
        ...state,
        type: action.payload
      };
    }
  }
  return state;
}

export const InitSystemTypeState = (state: SystemTypeState) => state.type;
